import {
  Component,
  ElementRef,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { isNullOrUndefined } from 'util';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { PlaceService } from '../../../../services/place.service';
import { ToggleFeaturesModalData } from './toggle.features.modal.provider';
import set = Reflect.set;
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { EventSpiderModalComponent } from '../event.spider/event.spider.modal.component';
import {
  EventSpiderModalActions,
  EventSpiderModalData,
} from '../event.spider/event.spider.modal.provider';
import { ModalService } from '../../../../common/services/modal.service';

@Component({
  templateUrl: './toggle.features.modal.component.html',
  styleUrls: ['./toggle.features.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ToggleFeaturesModalComponent extends BaseComponent {
  public loading = false;
  public isDefaultPlaceCategory = false;
  public features: HubVisitorFeatureToggle;
  public account: ToggleFeaturesModalData;
  public itineraryLimitation = {
    limited: false,
    limitation: 6,
  };
  @ViewChild('tripPlannerSuccess') public tripPlannerSuccess: SuccessWrapComponent;
  @ViewChild('itinerarySuccess') public itinerarySuccess: SuccessWrapComponent;
  @ViewChild('placeCalendarSuccess') public placeCalendarSuccess: SuccessWrapComponent;
  @ViewChild('calendarViewLayoutSuccess')
  public calendarViewLayoutSuccess: SuccessWrapComponent;
  @ViewChild('manualEventsSuccess') public manualEventsSuccess: SuccessWrapComponent;
  @ViewChild('googleReviewsSuccess') public googleReviewsSuccess: SuccessWrapComponent;
  @ViewChild('facebookPostsSuccess') public facebookPostsSuccess: SuccessWrapComponent;
  @ViewChild('nearbyPlacesRightSuccess') public nearbyPlacesRightSuccess: SuccessWrapComponent;
  @ViewChild('eventByGeolocationSuccess') public eventByGeolocationSuccess: SuccessWrapComponent;
  @ViewChild('regionalAccountTypeSuccess') public regionalAccountTypeSuccess: SuccessWrapComponent;
  @ViewChild('placeByGeolocationTabSuccess')
  public placeByGeolocationTabSuccess: SuccessWrapComponent;
  @ViewChild('eventTicketUrlSuccess') public eventTicketUrlSuccess: SuccessWrapComponent;
  @ViewChild('nearbyEventsInPlaceSuccess') public nearbyEventsInPlaceSuccess: SuccessWrapComponent;
  @ViewChild('nearbyPlacesInEventeSuccess')
  public nearbyPlacesInEventeSuccess: SuccessWrapComponent;
  @ViewChild('placeLocationFilterSuccess') public placeLocationFilterSuccess: SuccessWrapComponent;
  @ViewChild('eventLocationFilterSuccess') public eventLocationFilterSuccess: SuccessWrapComponent;

  @ViewChild('accommodationSuccess') public accommodationSuccess: SuccessWrapComponent;
  @ViewChild('jobBoardSuccess') public jobBoardSuccess: SuccessWrapComponent;
  @ViewChildren('placeCategorySuccess') placeCategorySuccesses: QueryList<SuccessWrapComponent>;
  @ViewChildren('nearbyPlaceRightToggle') nearbyPlaceRightToggle: MatSlideToggle;

  constructor(
    private fb: FormBuilder,
    private accountApiService: AccountApiService,
    private alertify: AlertifyService,
    private modalService: ModalService,
    private dialogRef: MatDialogRef<ToggleFeaturesModalComponent>,
    data: ToggleFeaturesModalData
  ) {
    super();
    this.account = Object.assign({}, data);
    this.features = this.account.account.toggle;
  }

  ngOnInit() {
    this.loading = true;
    this.accountApiService.getToggles(this.account.account._id).subscribe((toggle) => {
      if (toggle && toggle.toggle) {
        this.isDefaultPlaceCategory = toggle.isDefaultPlaceCategory;
        this.features.tripPlanner = isNullOrUndefined(toggle.toggle.tripPlanner)
          ? true
          : toggle.toggle.tripPlanner;
        this.features.calendarViewLayout = isNullOrUndefined(toggle.toggle.calendarViewLayout)
          ? false
          : toggle.toggle.calendarViewLayout;
        this.features.itinerary = isNullOrUndefined(toggle.toggle.itinerary)
          ? true
          : toggle.toggle.itinerary;
        this.features.placeCalendar = isNullOrUndefined(toggle.toggle.placeCalendar)
          ? true
          : toggle.toggle.placeCalendar;
        this.features.manualEvents = isNullOrUndefined(toggle.toggle.manualEvents)
          ? true
          : toggle.toggle.manualEvents;
        this.features.eventByGeolocation = isNullOrUndefined(toggle.toggle.eventByGeolocation)
          ? true
          : toggle.toggle.eventByGeolocation;
        this.features.regionalAccountType = isNullOrUndefined(toggle.toggle.regionalAccountType)
          ? false
          : toggle.toggle.regionalAccountType;
        this.features.googleReviews = isNullOrUndefined(toggle.toggle.googleReviews)
          ? true
          : toggle.toggle.googleReviews;
        this.features.facebookPosts = isNullOrUndefined(toggle.toggle.facebookPosts)
          ? true
          : toggle.toggle.facebookPosts;
        this.features.nearbyPlacesRight = isNullOrUndefined(toggle.toggle.nearbyPlacesRight)
          ? false
          : toggle.toggle.nearbyPlacesRight;
        this.features.googlePlaceGeofence = isNullOrUndefined(toggle.toggle.googlePlaceGeofence)
          ? true
          : toggle.toggle.googlePlaceGeofence;
        this.features.tour =
          isNullOrUndefined(toggle.tour) || isNullOrUndefined(toggle.tour.limit.limited)
            ? {
                limit: {
                  limited: false,
                  limitation: 6,
                },
                audioTour: false,
              }
            : toggle.tour;
        this.features.placeCategory = isNullOrUndefined(toggle.toggle.placeCategory.activity)
          ? {
              activity: true,
              accommodation: true,
              shopping: true,
              dining: true,
              outdoor: true,
              wellness: true,
              entertainment: true,
              travel: true,
              other: true,
              art: true,
            }
          : toggle.toggle.placeCategory;
        this.features.clientDashboard = {
          placeByGeoLocationTab: isNullOrUndefined(
            toggle.toggle.clientDashboard.placeByGeoLocationTab
          )
            ? true
            : toggle.toggle.clientDashboard.placeByGeoLocationTab,
        };
        this.features.nearbyEventsInPlace = isNullOrUndefined(toggle.toggle.nearbyEventsInPlace)
          ? false
          : toggle.toggle.nearbyEventsInPlace;
        this.features.nearbyPlacesInEvent = isNullOrUndefined(toggle.toggle.nearbyPlacesInEvent)
          ? false
          : toggle.toggle.nearbyPlacesInEvent;
        this.features.eventTicketUrl = isNullOrUndefined(toggle.toggle.eventTicketUrl)
          ? true
          : toggle.toggle.eventTicketUrl;
        this.features.eventLocationFilter = toggle.toggle.eventLocationFilter;
        this.features.placeLocationFilter = toggle.toggle.placeLocationFilter;
        this.features.jobBoard = toggle.toggle.jobBoard;
      }
      this.loading = false;
    });
  }

  public toggleTripPlanner() {
    this.features.tripPlanner = !this.features.tripPlanner;
    this.accountApiService
      .toggleTripPlanner(this.account.account._id, this.features.tripPlanner)
      .subscribe((data) => {
        this.tripPlannerSuccess.success();
      });
  }

  public toggleItinerary() {
    this.features.itinerary = !this.features.itinerary;
    this.accountApiService
      .toggleItinerary(this.account.account._id, this.features.itinerary)
      .subscribe((data) => {
        this.itinerarySuccess.success();
      });
  }

  public togglePlaceCalendar() {
    this.features.placeCalendar = !this.features.placeCalendar;
    this.accountApiService
      .togglePlaceCalendar(this.account.account._id, this.features.placeCalendar)
      .subscribe((data) => {
        this.placeCalendarSuccess.success();
      });
  }

  public toggleCalendarViewLayout() {
    this.features.calendarViewLayout = !this.features.calendarViewLayout;
    this.accountApiService
      .toggleCalendarViewLayout(this.account.account._id, this.features.calendarViewLayout)
      .subscribe((data) => {
        this.calendarViewLayoutSuccess.success();
      });
  }

  public toggleManualEvents() {
    this.features.manualEvents = !this.features.manualEvents;
    this.accountApiService
      .toggleEventCalendar(this.account.account._id, this.features.manualEvents)
      .subscribe((data) => {
        this.manualEventsSuccess.success();
      });
  }

  public toggleGoogleReviews() {
    this.features.googleReviews = !this.features.googleReviews;
    this.accountApiService
      .toggleGoogleReviews(this.account.account._id, this.features.googleReviews)
      .subscribe((data) => {
        this.googleReviewsSuccess.success();
      });
  }

  public toggleFacebookPosts($event) {
    if (!this.features.facebookPosts && this.features.nearbyPlacesRight) {
      alert(
        `You need to turn off the set nearby place to the right of the screen first, otherwise there is no enough space for the Facebook posts!`
      );
      setTimeout(() => {
        $event.source.checked = false;
      });
      return;
    }
    this.features.facebookPosts = !this.features.facebookPosts;
    this.accountApiService
      .toggleFacebookPosts(this.account.account._id, this.features.facebookPosts)
      .subscribe((data) => {
        this.facebookPostsSuccess.success();
      });
  }

  public toggleNearbyPlacesRight($event) {
    if (this.features.facebookPosts && !this.features.nearbyPlacesRight) {
      alert(
        `You need to turn off the Facebook posts first, otherwise there is no enough space for the nearby places!`
      );
      setTimeout(() => {
        $event.source.checked = false;
      });
      return;
    }
    this.features.nearbyPlacesRight = !this.features.nearbyPlacesRight;
    this.accountApiService
      .toggleNearbyPlacesRight(this.account.account._id, this.features.nearbyPlacesRight)
      .subscribe((data) => {
        this.nearbyPlacesRightSuccess.success();
      });
  }

  public toggleEventByGeolocation() {
    this.features.eventByGeolocation = !this.features.eventByGeolocation;
    this.accountApiService
      .toggleEventByGeolocation(this.account.account._id, this.features.eventByGeolocation)
      .subscribe((data) => {
        this.eventByGeolocationSuccess.success();
      });
  }

  public toggleJobBoard() {
    this.features.jobBoard = !this.features.jobBoard;
    this.accountApiService
      .toggleJobBoard(this.account.account._id, this.features.jobBoard)
      .subscribe((data) => {
        this.jobBoardSuccess.success();
      });
  }

  public toggleRegionalAccountType() {
    this.features.regionalAccountType = !this.features.regionalAccountType;
    this.accountApiService
      .toggleRegionalAccountType(this.account.account._id, this.features.regionalAccountType)
      .subscribe((data) => {
        this.regionalAccountTypeSuccess.success();
      });

    if (this.features.regionalAccountType) {
      this.account.account.toggle.regionalAccountType = true;
      this.modalService.show({
        component: EventSpiderModalComponent,
        providers: [
          { provide: EventSpiderModalActions, useValue: new EventSpiderModalActions() },
          {
            provide: EventSpiderModalData,
            useValue: new EventSpiderModalData(this.account.account),
          },
        ],
        panelClass: 'width-modal-70p',
      });
    } else {
      this.account.account.toggle.regionalAccountType = false;
    }
  }

  public togglePlaceCategory(category, index) {
    this.features.placeCategory[category] = !this.features.placeCategory[category];
    this.accountApiService
      .togglePlaceCategory(this.account.account._id, this.features.placeCategory)
      .subscribe((data) => {
        this.placeCategorySuccesses.toArray()[index].success();
        //this.turnOffPlaceIfAllCategoriesAreTurnedOff();
      });
  }

  public togglePlaceClientDashboardPlaceByGeolocationTab() {
    this.features.clientDashboard.placeByGeoLocationTab =
      !this.features.clientDashboard.placeByGeoLocationTab;
    this.accountApiService
      .togglePlaceByGeolocationTab(
        this.account.account._id,
        this.features.clientDashboard.placeByGeoLocationTab
      )
      .subscribe((data) => {
        this.placeByGeolocationTabSuccess.success();
      });
  }
  public toggleNearbyEventsInPlace() {
    this.features.nearbyEventsInPlace = !this.features.nearbyEventsInPlace;
    this.accountApiService
      .toggleNearbyEventsInPlace(this.account.account._id, this.features.nearbyEventsInPlace)
      .subscribe((data) => {
        this.nearbyEventsInPlaceSuccess.success();
      });
  }
  public togglePlaceLocationFilter() {
    this.features.placeLocationFilter = !this.features.placeLocationFilter;
    this.accountApiService
      .togglePlaceLocationFilter(this.account.account._id, this.features.placeLocationFilter)
      .subscribe((data) => {
        this.placeLocationFilterSuccess.success();
      });
  }
  public toggleEventLocationFilter() {
    this.features.eventLocationFilter = !this.features.eventLocationFilter;
    this.accountApiService
      .toggleEventLocationFilter(this.account.account._id, this.features.eventLocationFilter)
      .subscribe((data) => {
        this.eventLocationFilterSuccess.success();
      });
  }

  public toggleNearbyPlacesInEvent() {
    this.features.nearbyPlacesInEvent = !this.features.nearbyPlacesInEvent;
    this.accountApiService
      .toggleNearbyPlacesInEvent(this.account.account._id, this.features.nearbyPlacesInEvent)
      .subscribe((data) => {
        this.nearbyPlacesInEventeSuccess.success();
      });
  }

  public toggleEventTicketUrl() {
    this.features.eventTicketUrl = !this.features.eventTicketUrl;
    this.accountApiService
      .toggleEventTicketUrl(this.account.account._id, this.features.eventTicketUrl)
      .subscribe((data) => {
        this.eventTicketUrlSuccess.success();
      });
  }

  public saveTourLimitation(event: ButtonTriggerEvent) {
    this.accountApiService
      .setTourLimitation(this.account.account._id, {
        limit: this.features.tour.limit,
        googlePlaceGeofence: this.features.googlePlaceGeofence,
        audioTour: this.features.tour.audioTour,
      })
      .finally(event.complete)
      .subscribe((data) => {
        this.alertify.success('Set itinerary limitation and Google place geofence');
      });
  }

  private turnOffPlaceIfAllCategoriesAreTurnedOff() {
    let isAllTurnedOff = PlaceService.isAllCategoriesTurnedOff(this.features.placeCategory);
    if (isAllTurnedOff) {
      this.togglePlaceCalendar();
    }
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/toggle.features/toggle.features.modal.component.ts